module.exports = __webpack_public_path__ + "img/title-3.12532b60.png";